import React from 'react';
import './Qualifications.css';

const Qualifications = () => {
  return (
    <div className="qualificationsBox">
      <h4 style={{ textShadow: '0 0 5px #ddd, 0 0 10px #ccc, 0 0 15px #999' }}>
        Summary of Qualifications:
      </h4>
      <br />
      <br />
      <p>
      Innovative developer engineering digital experiences by transforming concepts into responsive, scalable applications and features using Modern Tech Stack Frameworks. Experienced across Frontend and Backend technologies, design tools, Content Management Systems, Continuous Deployment Pipelines, Cloud-Based Services, and API integrations. Driven to execute efficient technical solutions and create digital experiences that are equally accessible for all.
      </p>
      <div className="solid-line-q"></div>
    </div>
  );
};

export default Qualifications;
